import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlphabetOnlyDirective } from './service/alphabet-only.directive';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AlphabetOnlyDirective
    ],
    declarations: [
      AlphabetOnlyDirective
    ]
})
export class SharedModule
{
}
